module.exports = __webpack_public_path__ + "img/canada-cerebrovascular-disease-female.2c44e0b1.png";